<div class="signup-content-container">
    <ng-container *ngIf="planGroup.length && countries.length && selectedCountry; else signupInformationsLoading">
        <div class="signup-content-left">
            <form [formGroup]="signupForm" (ngSubmit)="onSubmit(signupForm.value)">
                <div class="signup-section-title">
                    {{ 'SIGNUP_PLANS_LISTBOX_TITLE' | translate }}
                </div>
                <div class="row">
                    <div class="input-container container-select-plan">
                        <ng-select placeholder="{{ 'SIGNUP_SMASH_PREMIUM' | translate }}" [items]="filteredPlanGroup"
                            [searchable]="false" [clearable]="false" formControlName="plan" [(ngModel)]="selectedPlan" (change)="onPlanChanged()">
                            <ng-template ng-label-tmp let-item="item">
                                <span>{{ item.name  }} - {{ item | planDurationInYearOrMonth }}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <span>{{ item.name  }} - {{ item | planDurationInYearOrMonth }}</span>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="signup-section-title">
                    {{ 'SIGNUP_USER_TITLE' | translate }}
                </div>
                <div class="row">
                    <div class="input-container container-input-lastname">
                        <app-smash-input borderStyle="full" formControlName="lastName"
                            placeholder="{{ 'SIGNUP_LASTNAME' | translate }}"
                            [error]="submitted && f.lastName.errors"></app-smash-input>
                    </div>
                    <div class="input-container container-input-firstname">
                        <app-smash-input borderStyle="full" formControlName="firstName"
                            placeholder="{{ 'SIGNUP_FIRSTNAME' | translate }}"
                            [error]="submitted && f.firstName.errors"></app-smash-input>
                    </div>
                </div>
                <ng-container *ngIf="accountIsPremium; else accountIsFreemium">
                    <div class="row">
                        <div class="input-container container-input-email">
                            <app-smash-input borderStyle="full" placeholder="{{ 'SIGNUP_EMAIL' | translate }}"
                                type="email" [disabled]="true" [value]="account.username">
                            </app-smash-input>
                        </div>
                        <div class="input-container container-input-password">
                            <app-smash-input borderStyle="full" placeholder="{{ 'SIGNUP_PASSWORD' | translate }}"
                                type="password" autocomplete="new-password" [disabled]="true" value="XXXXXXXXXXXX">
                            </app-smash-input>
                        </div>
                    </div>
                </ng-container>
                <ng-template #accountIsFreemium>
                    <div class="row">
                        <div class="input-container container-input-email">
                            <app-smash-input borderStyle="full" formControlName="email"
                                placeholder="{{ 'SIGNUP_EMAIL' | translate }}" type="email"
                                (valueChange)="onEmailChanges()" (inputFocus)="focusEmail(value)"
                                (inputBlur)="blurEmail(value)"
                                [error]="(submitted && f.email.errors) || (f.email.dirty && f.email.errors ) || (!emailChanged && !!f.email && !!f.email.value && errorSubscription === 'EMAIL_ALREADY_EXISTS')">
                            </app-smash-input>
                            <div class="input-error"
                                *ngIf="emailBlur && f.email.dirty && f.email.errors || (!emailChanged && !!f.email && !!f.email.value && errorSubscription === 'EMAIL_ALREADY_EXISTS')">
                                {{ 'SIGNUP_ALERT_MESSAGE_INCORRECT_EMAIL' | translate }}</div>
                        </div>
                        <div class="input-container container-input-password">
                            <app-smash-input borderStyle="full" 
                                formControlName="password"
                                autocomplete="new-password"
                                (inputFocus)="focusPassword(value)" 
                                (inputBlur)="blurPassword(value)"
                                placeholder="{{ 'SIGNUP_PASSWORD' | translate }}" 
                                type="password"
                                [error]="f.password && f.password.errors && (submitted  || f.password.dirty )">
                            </app-smash-input>
                            <div class="input-error" *ngIf="passwordBlur && f.password.dirty && f.password.errors">
                                {{
                                'SIGNUP_ALERT_MESSAGE_INVALID_PASSWORD' | translate }}</div>
                        </div>
                    </div>
                </ng-template>
                <div class="signup-section-title">
                    {{ 'SIGNUP_INVOICE_TITLE' | translate }}
                </div>
                <div class="row">
                    <div class="input-container container-input-companyname">
                        <app-smash-input borderStyle="full" formControlName="company"
                            placeholder="{{ 'SIGNUP_COMPANYNAME' | translate }}"
                            [error]="submitted && f.company.errors">
                        </app-smash-input>
                    </div>
                </div>
                <div class="row">
                    <div class="input-container container-input-streetaddress">
                        <app-smash-input borderStyle="full" formControlName="address"
                            placeholder="{{ 'SIGNUP_ADDRESS' | translate }}" [error]="submitted && f.address.errors">
                        </app-smash-input>
                    </div>
                    <div class="input-container container-input-city">
                        <app-smash-input borderStyle="full" formControlName="city"
                            placeholder="{{ 'SIGNUP_CITY' | translate }}" [error]="submitted && f.city.errors">
                        </app-smash-input>
                    </div>
                </div>
                <div class="row">
                    <div class="input-container container-input-zipcode">
                        <app-smash-input borderStyle="full" formControlName="zipCode"
                            placeholder="{{ 'SIGNUP_ZIPCODE' | translate }}" [error]="submitted && f.zipCode.errors">
                        </app-smash-input>
                    </div>
                    <div class="input-container container-input-country">
                        <ng-select [items]="countries" bindLabel="label" [searchable]="true" [clearable]="false"
                            formControlName="country" [(ngModel)]="selectedCountry">
                        </ng-select>
                    </div>
                </div>
                <div class="row" *ngIf="selectedCountry.eu">
                    <div class="input-container container-input-vat">
                        <app-smash-input borderStyle="full" formControlName="vatNumber"
                            placeholder="{{ 'SIGNUP_BILLING_VAT' | translate }}" (valueChange)="onVatNumberChanges()"
                            [error]="!vatNumberChanged && !!f.vatNumber && !!f.vatNumber.value && errorSubscription === 'vatNumber'">
                        </app-smash-input>
                        <div class="input-error"
                            *ngIf="!vatNumberChanged && !!f.vatNumber && !!f.vatNumber.value && errorSubscription === 'vatNumber'">
                            {{
                            'MODAL_SIGNUP_WRONG_VATNUMBER' | translate }}</div>
                    </div>
                </div>
                <div class="row" *ngIf="selectedCountry.states">
                    <div class="input-container container-input-vat">
                        <ng-select [ngClass]="{'error': submitted && f.state.errors }" [items]="selectedCountry.states" bindLabel="label" [searchable]="true"
                            [clearable]="true" placeholder="{{ 'SIGNUP_STATE' | translate }}" formControlName="state" [(ngModel)]="selectedState">
                        </ng-select>
                    </div>
                </div>
                <div class="signup-section-title">
                    {{ 'SIGNUP_PAYMENT_TITLE' | translate }}
                    <span class="icons8-lock"></span>
                </div>
                <div class="row container-input-payment-type">
                    <label class="container-input-payment-type-left" *ngIf="isStripeCardPaymentMethodsEnabled">
                        <input class="input-radio" type="radio" formControlName="payment_type" value="card"
                            [checked]="f.payment_type.value ==='card'">
                        <span class="signup-content-left-payment-methods-credit-card"></span>
                        <span class="signup-content-left-payment-methods-visa"></span>
                        <span class="signup-content-left-payment-methods-mastercard"></span>
                        <span class="signup-content-left-payment-methods-amex"></span>
                    </label>
                    <label class="container-input-payment-type-right" *ngIf="isPaypalPaymentMethodsEnabled">
                        <input class="input-radio" type="radio" formControlName="payment_type" value="paypal"
                            [checked]="f.payment_type.value ==='paypal'">
                        <span class="signup-content-left-payment-methods-paypal"></span>
                    </label>
                </div>
                <div class="row" *ngIf="isStripeCardPaymentMethodsEnabled && f.payment_type.value === 'card'">
                    <app-smash-stripe
                        [error]="(submitted && (f.card_token.invalid || (f.card_token.errors && f.card_token.errors.required)))"
                        style="width: 100%"
                        (stripeDataUpdated)="stripeDataUpdated($event)"></app-smash-stripe>
                </div>
                <div class="input-error"
                    *ngIf="f.card_token.invalid && f.card_token.errors && f.card_token.errors.incorrect">{{
                    'SIGNUP_ERROR_CARDNUMBER' | translate }}</div>

                <div class="row signup-terms-section">
                    <label class="signup-terms-label">
                        <app-smash-checkbox formControlName="terms"></app-smash-checkbox>
                        <span class="signup-terms-text" translate>SIGNUP_ACCEPT_CGV_PART_1</span>
                        <a href="{{ 'SIGNUP_ACCEPT_CGV_LINK' | translate }}" class="signup-terms-link"
                            target="_blank">{{
                            'SIGNUP_ACCEPT_CGV_PART_2' | translate
                            }}</a>
                    </label>
                </div>
                <div class="signup-error-container">
                    <div class="signup-error" *ngIf="submitted && signupForm.invalid ">
                        {{ 'SIGNUP_ERROR_FIELDS' | translate }}
                    </div>
                    <div class="signup-error"
                        *ngIf="!emailChanged && !!f.email && !!f.email.value && errorSubscription === 'EMAIL_ALREADY_EXISTS'">
                        {{ 'SIGNUP_EMAIL_ALREADY_USE' | translate }}
                    </div>
                </div>
                <div class="signup-button-container" *ngIf="computedPlan">
                    <button class="btn green large signup-button"
                        type="submit">{{
                        'SIGNUP_BUTTON_PAY' | translate }}
                        ({{computedPlan.priceInclTax  | priceFormater : { language, currency: selectedPlan.currency } }})</button>                    
                </div>
            </form>
        </div>
        <div class="signup-content-right">
            <div class="sticky-col">
                <app-smash-signup-summary *ngIf="computedPlan" 
                    (onSelectPlan)="choosePlanFromSummary($event)"    
                    [computedPlan]="computedPlan" 
                    [selectedPlan]="selectedPlan" 
                    [plans]="planGroup"
                    [selectedCountry]="selectedCountry"
                    [language]="language"></app-smash-signup-summary>
                <div class="signup-content-right-contact">
                    <div class="signup-content-right-contact-title">{{ 'SIGNUP_CONTACT_US_TITLE' | translate }}</div>
                    <div class="signup-content-right-contact-text">{{ 'SIGNUP_CONTACT_US_TEXT' | translate }}</div>
                    <div class="signup-content-right-contact-text">{{ 'SIGNUP_CONTACT_US_EMAIL_LEGEND' | translate }} :
                        <a class="signup-content-right-contact-link" href="mailto:sales@fromsmash.com">{{
                            'SIGNUP_CONTACT_US_EMAIL' | translate }}</a>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #signupInformationsLoading>
        <div class="spinner-container">
            <app-smash-loading-spinner></app-smash-loading-spinner>
        </div>
    </ng-template>
</div>